import jwt_decode from 'jwt-decode'

export function isValidJWT (token: string): boolean {
  if (typeof token !== 'string') return false

  const parts = token.split('.')
  if (parts.length !== 3) return false

  try {
    const decoded = jwt_decode(token)
    return typeof decoded === 'object' && decoded !== null
  } catch (e) {
    return false
  }
}
